import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { AppContext } from "@my-dld/contexts/AppContext";
import { Route, Switch } from "react-router";
import JOPServicesSelection from "./JOPServicesSelection";
import JOPService from "./JOPService";
import JOPContextWrapper from "@my-dld/contexts/JOPContext";

export enum JOPServiceIds {
	ENQUIRY = 1,
	SUGGESTION = 2,
	COMPLAINT = 3,
	LEGAL = 4,
}

export enum JOPUserType {
	OWNER = 413,
	TENANT = 414,
}

class JOPServices extends Component<RoutedViewProps> {
	static contextType = AppContext;
	context!: React.ContextType<typeof AppContext>;

	render() {
		const pp = this.props.match.url;
		return <JOPContextWrapper>
			<Switch>
				<Route path={ pp } exact={ true } component={ JOPServicesSelection }/>
				<Route path={ pp + `/${ JOPServiceIds.ENQUIRY }` } render={ props => <JOPService { ...props } type={ "enquiry" }/> }/>
				<Route path={ pp + `/${ JOPServiceIds.SUGGESTION }` } render={ props => <JOPService { ...props } type={ "suggestion" }/> }/>
				<Route path={ pp + `/${ JOPServiceIds.COMPLAINT }` } render={ props => <JOPService { ...props } type={ "complaints" }/> }/>
				<Route path={ pp + `/${ JOPServiceIds.LEGAL }` } render={ props => <JOPService { ...props } type={ "legal" }/> }/>
			</Switch>
		</JOPContextWrapper>;
	}
}

export default JOPServices;
